<template>

    <dropdown-search-menu :options="{
            inputIcon: 'far fa-coins',
            placeholder: __('labels.currency.select_or_create'),
            title_clear: __('labels.basics.clear')
        }"
        :keys="$store.state.currencies.infinity.columns"
        :selectkeys="['iso_code']"
        v-model:search="search"
        :selected="selValue"
        :values="values"
        :is-loading="values_loading"
        :selectElementOnUnfocus="valTrue"
        @dropdown:select="select"
        @dropdown:clear="clearValues()"
        @menu:loadmore="$store.dispatch('currencies/load')"
        >
        <slot name="label" >

        </slot>
    </dropdown-search-menu>
</template>
<script>
export default {
    props: {
        value : {}
    },
    components: {

    },
    setup() {

    },
    data() {
        return {
            search: "",
            selValue : "",
            selected: {
                name : "",
                id : 0,
            },
            debounce : {
                searchCompany : null,
            }
        }
    },
    mounted() {
        this.$store.dispatch("currencies/load");
        if(this.value && this.value.id){
            this.selected.id = this.value.id;
            this.selected.name = this.value.name;
            this.search = this.value.name;
        }
    },
    methods: {
        clearValues(){
            this.selValue = 0;
            this.selected.name ="";
            this.selected.id = null;
            this.search = "";
            this.$emit('update:value', this.selected)
            this.$emit("dropdown:clear");
        },
        select(event, event2){
            this.selValue = event.id;
            this.selected.name = event.name;
            this.selected.id = event.id;
            this.search = event2;
            this.$emit('update:value', this.selected)
        },
        searchCompanies(event) {
            if (this.debounce.searchCompany)
                clearTimeout(this.debounce.searchCompany);

            this.debounce.searchCompany = setTimeout(() => {
                this.$store.commit("currencies/setSearch", event);
                this.$store.dispatch("currencies/load");
            }, 300); // delay
        },
    },
    computed: {
        valTrue(){
            return true;
        },
        columns() {
            return this.$store.state.currencies.infinity.columns
        },
        values() {
            return this.$store.state.currencies.list;
        },
        values_loading() {
            return this.$store.state.currencies.loading;
        },
    }
}
</script>
